<template>
    <v-layout row wrap>
        <v-flex xs10 offset-xs1 lg8 offset-lg2>

            <v-form v-model="valid" ref="form" @submit.prevent="submit">
                <v-card class="pa-3" v-if="!loading">
                    <v-card-text>
                        <v-alert color="error" icon="error" value="true" class="mb-3" v-if="!form.isActive">
                            {{ $t('message.info.demandTypeInactive') }}
                        </v-alert>
                        <!-- <v-alert color="warning" icon="warning" value="true" class="mb-3" v-else-if="form.isInUse">
                            {{ $t('message.info.demandTypeInUse') }}
                        </v-alert> -->

                        <div class="subheading mb-3">{{ $t('title.demandType') }}</div>
                        <v-layout row>
                            <v-flex xs3 lg2>
                                <label class="form-label">{{ $t('label.name') }}*</label>
                            </v-flex>
                            <v-flex xs9 lg10>
                                <v-text-field :disabled="disabled" v-model="form.name" :rules="validation.text" :counter="constants.LENGTH_TYPE_DEMAND_NAME" :maxlength="constants.LENGTH_TYPE_DEMAND_NAME"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs3 lg2>
                                <label class="form-label">{{ $t('label.description') }}*</label>
                            </v-flex>
                            <v-flex xs9 lg10>
                                <v-text-field multi-line :disabled="disabled" v-model="form.description" :rules="validation.text" autoGrow :counter="constants.LENGTH_TYPE_DEMAND_DESCRIPTION" :maxlength="constants.LENGTH_TYPE_DEMAND_DESCRIPTION"></v-text-field>
                            </v-flex>
                        </v-layout>

                        <div class="subheading">{{ $t('label.approvalCycle') }}</div>
                        <p v-html="$t('message.info.demandTypeApprovers')"></p>
                        <v-layout row v-for="status in statuses" :key="status">
                            <v-flex xs3>
                                <label class="form-label">{{ $t('type.status')[status] }}</label>
                            </v-flex>
                            <v-flex xs9>
                                <app-step v-for="step in filterSteps(status)" :key="step.uuid" :model="step" :list="filterSteps(status)" v-on:remove="removeStep" :disabled="disabled || form.isInUse" v-on:change="updateStep"></app-step>
                            </v-flex>
                        </v-layout>
                    </v-card-text>

                    <v-card-actions v-if="!disabled">
                        <v-btn :loading="saving" :disabled="removing" @click="save" color="primary">
                            {{ $t('label.save') }}
                        </v-btn>

                        <v-menu v-if="!form.isInUse">
                            <v-btn :disabled="saving || removing" slot="activator">
                                <v-icon class="mr-3">supervisor_account</v-icon>
                                {{ $t('label.addStep') }}
                            </v-btn>
                            <v-list>
                                <v-list-tile v-for="status in statuses" :key="status" @click="addStep(status)">
                                    <v-list-tile-title>{{ $t('type.status')[status] }}</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>

                        <v-btn :disabled="saving" :loading="removing" @click="remove" color="error" v-if="!!form.id">
                            {{ form.isInUse ? $t('label.inactivate') : $t('label.remove') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
                <v-card v-else>
                    <app-card-loader></app-card-loader>
                </v-card>
            </v-form>
        </v-flex>
    </v-layout>
</template>

<script>
import constants from '@/helpers/constants';
import utilities from '@/helpers/utilities';
import validation from '@/helpers/validation';

import CardLoader from '@/components/shared/CardLoader';
import DemandType from '@/helpers/entities/DemandType';
import Step from './Step';

export default {
    data() {
        return {
            constants,
            validation,
            valid: true,
            removing: false,
            saving: false,
            loading: true,

            statuses: [
                constants.STATUS_CREATED_APPROVAL,
                constants.STATUS_PLANNING_APPROVAL,
                constants.STATUS_DELIVERY_APPROVAL,
                constants.STATUS_FINALIZING,
            ],

            form: DemandType.build(),
        };
    },

    computed: {
        disabled() {
            return !this.$store.getters.isAdmin ||
                !this.form.isActive;
        },
    },

    components: {
        appStep: Step,
        appCardLoader: CardLoader,
    },

    watch: {
        $route: 'fetch',
    },

    created() {
        this.fetch();
    },

    methods: {
        addStep(status) {
            this.form.steps.splice(this.form.steps.length, 0, DemandType.step.build(status));
        },
        filterSteps(status) {
            return this.form.steps.filter(step => step.status.id === status);
        },
        removeStep(uuid) {
            const index = this.form.steps.map(step => step.uuid).indexOf(uuid);
            this.form.steps.splice(index, 1);
        },
        updateStep(obj) {
            const index = this.form.steps.map(step => step.uuid).indexOf(obj.uuid);
            this.form.steps.splice(index, 1, obj);
        },

        async fetch() {
            this.loading = true;

            if (!utilities.isEmptyOrZero(this.$route.params.id)) {
                await this.$store.dispatch('fetchDemandType', this.$route.params.id);
                this.form = DemandType.toForm(this.$store.getters.demandType);
            }

            this.loading = false;
        },

        async remove() {
            this.removing = true;
            await this.$store.dispatch('removeDemandType', this.form);
            this.$router.push({ name: 'typeDemandIndex' });
        },

        async save() {
            if (!this.$refs.form.validate()) return;

            this.saving = true;
            await this.$store.dispatch('saveOrUpdateDemandType', DemandType.toPayload(this.form));
            this.$router.push({ name: 'typeDemandIndex' });
        },
    },
};
</script>




// WEBPACK FOOTER //
// src/components/types/demand/Edit.vue